import React, { FC } from 'react'
import { RPUser } from '@hazadapt-git/public-core-base'
import { Dialog, LoadingButton } from '../atoms'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import { useOrganization } from '../../lib/hooks/useOrganization'

interface TeamMemberDeleteModalProps {
    user: RPUser
    open?: boolean
    onClose(): void
}

export const TeamMemberDeleteModal: FC<TeamMemberDeleteModalProps> = ({
    user,
    open,
    onClose,
}) => {
    const { handleRemoveUser } = useOrganization()

    const onDeleteUser = async (user: RPUser) => {
        await handleRemoveUser(user)
        onClose()
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            title="Remove Team Member"
            content={
                <Typography>
                    Are you sure you want to remove {user.first_name}{' '}
                    {user.last_name} from your organization? You can always add
                    them back later.
                </Typography>
            }
            ctas={[
                <Button
                    color="secondary"
                    variant="outlined"
                    onClick={onClose}
                    key="cancel"
                >
                    Cancel
                </Button>,
                <LoadingButton
                    key="remove-from-organization"
                    onClickAsync={async () => {
                        await onDeleteUser(user)
                    }}
                    variant="contained"
                    color="error"
                >
                    Remove from Organization
                </LoadingButton>,
                //! When Pause User Functionality is added, uncomment this
                // <Button onClick={handleClose} variant="outlined">
                //     Pause Org Access
                // </Button>,
            ]}
        />
    )
}
